module.exports = __webpack_public_path__ + "img/24.12dbc6dc.jpg";